import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_EQUIPOS_JUEGOS,
  ALL_EQUIPOS_JUEGOS,
  LOADING_ALL_EQUIPOS_JUEGOS,
} from './EquiposJuegosReducer';
import {
  deleteEquiposJuegosService,
  allEquiposJuegosService,
  oneEquiposJuegosService,
  saveEquiposJuegosService,
} from './EquiposJuegosService';

export const allEquiposJuegosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_EQUIPOS_JUEGOS, payload: true });
    const res = await allEquiposJuegosService(params);
    dispatch({ type: ALL_EQUIPOS_JUEGOS, payload: res.data });
    dispatch({ type: LOADING_ALL_EQUIPOS_JUEGOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_EQUIPOS_JUEGOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEquiposJuegosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEquiposJuegosService(id, data);
    notify(res.data.message);
    await allEquiposJuegosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEquiposJuegosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_EQUIPOS_JUEGOS, payload: data });
};

export const oneEquiposJuegosAction = async (dispatch, id) => {
  try {
    const res = await oneEquiposJuegosService(id);
    await setActivoEquiposJuegosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEquiposJuegosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEquiposJuegosService(id);
    notify(res.data.message);
    await setActivoEquiposJuegosAction(dispatch, null);
    await allEquiposJuegosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
